<form [formGroup]="form">
  <div>
    <mat-form-field class="field" [floatLabel]="'always'" subscriptSizing="dynamic">
      <mat-label>{{ labelText() || documentType() | human }}</mat-label>
      <input type="text"
              [placeholder]="placeholderText() || 'Buscar'"
              aria-label="Buscar documento"
              matInput
              formControlName="document_id"
              [matAutocomplete]="autoDocument">
      <span matTextPrefix>
        @if (loading()) {
          <mat-spinner diameter="15"></mat-spinner>
        } @else {
          {{prefix()}}&nbsp;
        }
      </span>
      <mat-autocomplete #autoDocument="matAutocomplete" [displayWith]="displayDocumentFn">
        @for(document of documents(); track document.id) {
          <mat-option [value]="document">
            <div class="option-wrapper">
              <div class="option-left">
                @switch (documentType()) {
                  @case('Budget') {
                    <span><b>#{{ document.correlative_id  }}</b></span>
                    <span class="option-field">{{'object' | human}}: {{ document.object?.identifier }}</span>
                    <span class="option-field">{{'client' | human}}: {{ document.client?.name }}</span>
                  }
                  @case('Invoice::Sale') {
                    <span><b>{{document.invoice_type | human}} Nº {{ document.correlative_id  }}</b></span>
                    <span class="option-field">Fecha de Pago: {{ document.due_date | date }}</span>
                    <span class="option-field">{{'total' | human}}: {{ document.total | money }}</span>
                    <span class="option-field">{{'client' | human}}: {{ document.stakeholder?.name }}</span>
                  }
                  @case('Order') {
                    <span><b>#{{ document.correlative_id  }}</b></span>
                    <span class="option-field">{{'object' | human}}: {{ document.object?.identifier }}</span>
                    <span class="option-field">{{'client' | human}}: {{ document.client?.name }}</span>
                  }
                  @default {
                    <span><b>{{ document[displayWith()] }}</b></span>
                  }
                }
              </div>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
</form>
